import React from "react";
import { Skeleton } from "primereact/skeleton";

interface DetailLoaderProps {
    className?: string;
    contentCount?: number;
}

const DetailLoader: React.FC<DetailLoaderProps> = ({ className, contentCount = 6 }) => {
    const loadingContent = Array.from({ length: contentCount });

    return (
        <article className={`detail_container_area ${className ? className : ''}`}>
            <div className="detail_container_header">
                <Skeleton className="detail_head_loader " />
            </div>

            <div className="detail_container_body">
                <div className="detail_container">
                    {loadingContent?.map((_, index) => (
                        <div
                            key={index}
                            className={`detail_content_group ${index === loadingContent.length - 1 ? 'no_divider' : ''}`}
                        >
                            <Skeleton className="detail_head_loader" />
                            <Skeleton className="detail_sub_head_loader" />
                        </div>
                    ))}

                    <div className="detail_content_group custom with_bg">
                        <Skeleton className="detail_head_loader" />
                        <Skeleton className="detail_sub_head_loader mb-1 full" />
                        <Skeleton className="detail_sub_head_loader" />
                    </div>
                </div>
            </div>
        </article>
    )
}

export default DetailLoader;